/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : PRODUCT MANAGER CONTROLBAR : STYLES --------------- ++++++++++ */
export default theme => ({
  placeholder: {
    background: '#EEEFF1',
    height: pxToEm(10),
    borderRadius: pxToEm(8),
    width: '100%'
  }
});
